module.exports = __webpack_public_path__ + "static/media/usman_pic.7c812223.png";